import type { AppRouteRecord } from '../types';
import { ROUTE_NAMES, ROUTE_PATHS } from '../constants';

export const dashboardRoutes: AppRouteRecord[] = [
  {
    path: ROUTE_PATHS.DASHBOARD,
    name: ROUTE_NAMES.DASHBOARD,
    component: () => import('@/pages/DashboardPage.vue'),
  },
];
